<template>
  <el-dialog
    :append-to-body="true"
    :title="title"
    :visible.sync="show"
    :before-close="onClose"
  >
    <slot />
  </el-dialog>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Edit",
    },
    onClose: {
      type: Function,
      default: () => {},
    },
  },
};
</script>
